module.exports = __webpack_public_path__ + "images/application/logo-84e5b009.svg";